export const hasProfileExpression = (queryString: string): boolean => {
    return queryString.includes('?expression=(profile:')
}